/* eslint-disable global-require */
const axios = require('axios')

async function getAttendents(acessToken) {
  const attendentsList = await axios.get('https://app.manyconvert.com/api/attendants', {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return attendentsList
}

export default async function attendents() {
  const userData = JSON.parse(localStorage.getItem('userData'))
  // se for adm busca atendentes, se não, inseri os próprios dados
  const attendantsList = userData.role === 'admin' ? getAttendents(userData.mc_access_token) : [{ id: userData.id, name: userData.username }]
  return attendantsList
}
